<template>
  <div>
    <v-card class="ml-1 mr-1 generic-card" style="border-radius: 20px; margin: 0; margin-top: 5px">
      <div style="padding: 10px 15px; border-bottom: 1px solid #eee">
        <v-layout align-center>
          <v-flex shrink class="text-xs-left">
            <slot name="move"></slot>
            <a
              v-if="generic.image_url"
              class="mr-2 ml-2"
              href="javascript:void(0);"
              @click="showAddImgUrl"
            >
              <v-icon color="primary"> {{ linkurl ? 'link' : 'link_off' }} </v-icon>
            </a>
          </v-flex>
          <v-flex class="text-xs-center">
            <v-btn
              v-if="
                selectedBot.useketshop == true &&
                selectedBot.ketshop_api_key &&
                selectedBot.ketshop_api_secret
              "
              outline
              color="primary"
              small
              class="ma-0"
              @click="onChangeMode"
            >
              <template v-if="!isProductview">{{ $t('Change to Menu List Format') }}</template>
              <template v-else>{{ $t('Change to Product Format') }}</template>

              <v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
            </v-btn>
          </v-flex>
          <v-flex shrink class="text-xs-right">
            <a href="javascript:void(0);" class="mx-2" @click="onCopyGenericCard(generic)">
              <v-icon small color="primary">file_copy</v-icon>
            </a>
            <a href="javascript:void(0);" class="ml-2" @click="onGenericChange(generic)">
              <v-icon small color="primary">delete</v-icon>
            </a>
          </v-flex>
        </v-layout>
      </div>

      <template v-if="isProductview">
        <template v-if="currentProduct">
          <template
            v-if="currentProduct.photourl && currentProduct.photourl.split(';;').length > 0"
          >
            <v-img :src="currentProduct.photourl.split(';;')[0]" aspect-ratio="1" alt></v-img>
          </template>
          <div class="pl-2 pr-2 pt-2 strong">{{ currentProduct.name | truncate(40) }}</div>
          <div class="pl-2 pr-2 pb-2">{{ currentProduct.description | truncate(90) }}</div>

          <div class="text-xs-center">
            <v-btn flat color="primary" :loading="loadingProduct" @click="showProduct = true">{{
              $t('Choose product to display')
            }}</v-btn>
          </div>
        </template>
        <div v-else style="height: 200px">
          <v-layout column justify-center fill-height>
            <v-btn outline color="primary" :loading="loadingProduct" @click="showProduct = true">{{
              $t('Choose product to display')
            }}</v-btn>
          </v-layout>
        </div>

        <v-dialog v-model="showProduct">
          <v-card>
            <div class="text-xs-right">
              <v-btn fab small flat @click="showProduct = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm8>
                  <div style="overflow-x: auto; white-space: nowrap; padding-bottom: 15px">
                    <filter-category
                      v-model="currentCategory"
                      :categories="categories"
                      :stat="filterBadge"
                    ></filter-category>
                  </div>
                </v-flex>
                <v-flex xs12 sm4>
                  <div class="form-control">
                    <input
                      id="search"
                      v-model="search"
                      type="text"
                      name="search"
                      :placeholder="$t('Search')"
                    />
                  </div>
                </v-flex>
              </v-layout>
              <template v-if="filterProducts.length == 0">
                <v-alert :value="true" color="grey" icon="info" outline>{{
                  $t('No product found')
                }}</v-alert>
              </template>
              <template v-else>
                <div class="mt-2 mb-2 text-xs-center">
                  <v-pagination
                    v-model="pageNumber"
                    :length="pageCount"
                    @input="onClickPageinate"
                  ></v-pagination>
                </div>
                <v-layout wrap>
                  <v-flex
                    v-for="product in filterProducts"
                    :key="'product_' + product.id"
                    xs4
                    sm3
                    lg2
                    class="pa-2"
                  >
                    <v-card style="height: 100%">
                      <template v-if="product.photourl && product.photourl.split(';;').length > 0">
                        <v-img :src="product.photourl.split(';;')[0]" aspect-ratio="1" alt></v-img>
                      </template>
                      <v-card-text>{{ product.name | truncate(40) }}</v-card-text>
                      <v-card-actions>
                        <v-btn
                          small
                          depressed
                          color="primary"
                          style="width: 100%"
                          @click="onSelectProduct(product)"
                          >{{ $t('Select') }}</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
                <div class="mt-2 mb-2 text-xs-center">
                  <v-pagination
                    v-model="pageNumber"
                    :length="pageCount"
                    @input="onClickPageinate"
                  ></v-pagination>
                </div>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-else-if="generic">
        <div class="card-img">
          <uploadfile
            v-model="generic.image_url"
            v-validate="isValidate ? 'required' : ''"
            :height="ratio == 'horizontal' ? 157 : 300"
            data-vv-as="Generic Image"
            :data-vv-name="'generic_manage_' + vkey + '_image'"
            use-drive
            @onUploaded="onUploaded"
          ></uploadfile>
        </div>
        <div
          :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_image') }"
          style="padding: 0 10px"
        >
          <span
            v-show="errors.has('generic_manage_' + vkey + '_image')"
            class="error--text caption"
            >{{ errors.first('generic_manage_' + vkey + '_image') }}</span
          >
        </div>

        <div class="card-body" style="line-height: 25px">
          <div
            :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_title') }"
            style="padding: 5px"
          >
            <textarea
              id="title"
              v-model="generic.title"
              v-validate="isValidate ? 'required' : ''"
              name="title"
              style="width: 100%; resize: none; height: 50px; font-weight: 600"
              :maxlength="titlemaxlength"
              :data-vv-as="$t('Title')"
              :data-vv-name="'generic_manage_' + vkey + '_title'"
              class="form-control"
              :placeholder="$t('Enter Title')"
              @change="$emit('input', generic)"
            ></textarea>
            <span
              v-show="errors.has('generic_manage_' + vkey + '_title')"
              class="error--text caption"
              >{{ errors.first('generic_manage_' + vkey + '_title') }}</span
            >
          </div>

          <div
            :class="{ 'has-error': errors.has('generic_manage_' + vkey + '_subtitle') }"
            style="padding: 5px"
          >
            <textarea
              id="subtitle"
              v-model="generic.subtitle"
              v-validate="isValidate ? 'required' : ''"
              name="subtitle"
              style="width: 100%; resize: none; height: 70px"
              :maxlength="titlemaxlength"
              :data-vv-as="$t('Subtitle')"
              :data-vv-name="'generic_manage_' + vkey + '_subtitle'"
              class="form-control"
              :placeholder="$t('Enter Subtitle')"
              @change="$emit('input', generic)"
            ></textarea>
            <span
              v-show="errors.has('generic_manage_' + vkey + '_subtitle')"
              class="error--text caption"
              >{{ errors.first('generic_manage_' + vkey + '_subtitle') }}</span
            >
          </div>
        </div>
      </template>

      <ul v-if="generic" class="list-group list-group-flush" style="margin-bottom: 0px">
        <template v-if="generic.buttons.length > 0">
          <li
            v-for="(button, bindex) in generic.buttons"
            :key="bindex"
            class="list-group-item"
            style="
              border-left: none;
              border-right: none;
              border-bottom: none;
              border-top: 1px solid #eee;
              border-radius: 0px;
              text-align: center;
            "
          >
            <div v-if="button" style="padding: 10px 0; position: relative">
              {{ button.title }}
              <add-generic-button
                :key="'generic_button_' + bindex + '_' + editTimestamp"
                v-model="generic.buttons[bindex]"
                :is-edit="true"
                right="0px"
                @onSave="editButton(bindex, $event)"
              >
                <template slot="body">
                  &nbsp;
                  <!-- <span class="fa fa-pencil-alt"></span> -->
                </template>

                <template slot="append">
                  <v-list-tile :disabled="bindex <= 0" @click="onMoveButton(bindex, 'up', generic)">
                    <v-list-tile-title
                      :style="bindex <= 0 ? `color: lightgrey` : ''"
                      class="primary-color"
                      >{{ $t('Move up') }}</v-list-tile-title
                    >
                  </v-list-tile>
                  <v-list-tile
                    :disabled="bindex >= generic.buttons.length - 1"
                    @click="onMoveButton(bindex, 'down', generic)"
                  >
                    <v-list-tile-title
                      :style="bindex >= generic.buttons.length - 1 ? `color: lightgrey` : ''"
                      class="primary-color"
                      >{{ $t('Move down') }}</v-list-tile-title
                    >
                  </v-list-tile>
                  <v-list-tile @click="deleteButton(bindex)">
                    <v-list-tile-title class="primary-color">{{ $t('Delete') }}</v-list-tile-title>
                  </v-list-tile>
                </template>
              </add-generic-button>
            </div>
          </li>
        </template>
        <li
          v-if="generic.buttons.length < 3"
          class="list-group-item"
          style="
            border-left: none;
            border-right: none;
            border-bottom: none;
            border-top: 1px solid #eee;
            border-radius: 0px;
            text-align: center;
          "
        >
          <div style="padding: 10px 0">
            <add-generic-button
              :key="'generic_new_button_' + saveTimestamp"
              v-model="newButton"
              @onSave="addNewButton"
            >
              <template slot="body">
                <em class="fa fa-plus"></em>
                {{ $t('Add button') }}
              </template>
            </add-generic-button>
          </div>
        </li>
      </ul>
    </v-card>

    <generic-link-image
      v-if="showaddLink"
      v-model="showaddLink"
      :linkurl="linkurl"
      :linktype="linktype"
      :image_url="generic.image_url"
      @onchange="onSaveLinkImgUrl"
    ></generic-link-image>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import uploadfile from '@/components/elements/uploadfile'

import AddGenericButton from '@/components/view/chatbot/AddGenericButton'
import FilterCategory from '@/components/view/template/ecommerce/FilterCategory'
import moment from 'moment'
import GenericLinkImage from './GenericLinkImage'

export default {
  components: {
    uploadfile,
    AddGenericButton,
    FilterCategory,
    GenericLinkImage
  },
  inject: ['$validator'],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: {}
    },
    isValidate: {
      default: false,
      type: Boolean
    },
    vkey: {
      default: 0,
      type: [String, Number]
    },
    ratio: {
      type: String,
      default: 'square'
    }
  },
  data: function () {
    return {
      templink: '',
      templinktype: '',
      showaddLink: false,
      linktype: 'none',
      linkurl: '',
      currentCategory: 'all',
      isProductview: false,
      generic: this.value,
      showModal: false,
      showProduct: false,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      currentProduct: null,
      pageNumber: 1,
      size: 10,
      productCount: 0,
      search: '',
      filterBadge: undefined,
      editTimestamp: moment().format('x'),
      saveTimestamp: moment().format('x')
    }
  },
  computed: {
    titlemaxlength() {
      if (['centralhr', 'atomicboy'].includes(this.selectedBot.theme)) {
        return 9999
      } else {
        return 80
      }
    },
    subtitlemaxlength() {
      if (['centralhr', 'atomicboy'].includes(this.selectedBot.theme)) {
        return 9999
      } else {
        return 80
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    }),
    filterProducts: function () {
      let vm = this

      let products = []
      vm.filterBadge = {
        all: vm.products.length,
        sales: 0,
        soldout: 0
      }

      $.each(vm.products, function (index, val) {
        if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
          vm.filterBadge.sales += 1
        } else {
          var isDiscount = false
          if (val.productstock) {
            val.productstock.map(function (stock, sindex) {
              if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                isDiscount = true
              }
            })
          }

          if (isDiscount) {
            vm.filterBadge.sales += 1
          }
        }
        if (vm.currentCategory === 'sales') {
          if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
            products.push(val)
          } else {
            if (val.productstock) {
              val.productstock.map(function (stock, sindex) {
                if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                  isDiscount = true
                }
              })
            }

            if (isDiscount) {
              products.push(val)
            }
          }
        } else if (vm.currentCategory === val.categoryid) {
          products.push(val)
        }
        if (val.productstock.length === 0) {
          vm.filterBadge.soldout += 1
          if (vm.currentCategory === 'soldout') {
            products.push(val)
          }
        } else {
          $.each(val.productstock, function (sindex, stock) {
            if (stock[2] <= 0) {
              vm.filterBadge.soldout += 1
              if (vm.currentCategory === 'soldout') {
                products.push(val)
              }
              return false
            }
          })
        }
      })
      if (vm.currentCategory === 'all') {
        products = vm.products
      }

      var p = []
      if (vm.search === '') {
        p = products
      } else {
        p = products.filter((product) => {
          var isFoundSkuInStock = false
          if (product.productstock && product.productstock.length > 0) {
            var stocks = product.productstock.filter((stock) => {
              return (
                stock[5] &&
                stock[5] != null &&
                stock[5].toLowerCase().includes(vm.search.toLowerCase())
              )
            })
            isFoundSkuInStock = stocks.length > 0
          }
          return (
            product.name.toLowerCase().includes(vm.search.toLowerCase()) ||
            (product.code != null &&
              product.code.toLowerCase().includes(vm.search.toLowerCase())) ||
            isFoundSkuInStock
          )
        })
      }
      this.productCount = p.length

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return p.slice(start, end)
    },
    pageCount: function () {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  watch: {
    value: function () {
      this.generic = this.value
    },
    search: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    }
  },
  mounted: function () {
    var vm = this
    if (vm.generic.productid) {
      vm.isProductview = true
    }
    delete vm.generic.enable
    if (this.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      if (vm.generic.productid) {
        vm.currentProduct = vm.products.find(function (val) {
          return val.id == vm.generic.productid
        })
      }
    }
    var buttons = this.generic.buttons.filter((el) => {
      return el != null
    })
    this.$set(this.generic, 'buttons', buttons)
    if (this.generic.default_action && this.generic.default_action.url) {
      this.linkurl = this.generic.default_action.url
      if (this.generic.image_url && this.generic.image_url == this.linkurl) {
        this.linktype = 'imglink'
      } else {
        this.linktype = 'customlink'
      }
    }
  },
  methods: {
    onSaveLinkImgUrl(payload) {
      if (payload.linktype == 'none') {
        if (this.generic.default_action) delete this.generic.default_action
      } else {
        this.$set(this.generic, 'default_action', {
          type: 'web_url',
          url: payload.url
        })
      }

      this.linktype = payload.linktype
      this.linkurl = payload.url
    },
    onMoveButton: function (index, direction, item) {
      if (direction == 'up') {
        item.buttons.splice(index, 0, item.buttons.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        item.buttons.splice(index, 0, item.buttons.splice(index + 1, 1)[0])
      }
    },
    onCancelLinkUrl() {
      this.linkurl = this.templink
      this.linktype = this.templinktype
      this.showaddLink = false
    },
    onChangeImgUrl(value) {
      if (value == 'imglink') {
        this.linkurl = this.generic.image_url
      } else {
        this.linkurl = ''
      }
    },
    showAddImgUrl() {
      this.showaddLink = true
      this.templink = JSON.parse(JSON.stringify(this.linkurl))
      this.templinktype = JSON.parse(JSON.stringify(this.linktype))
    },
    onUploaded(url) {
      if (this.linktype == 'imglink') {
        this.$set(this.generic, 'default_action', {
          type: 'web_url',
          url: url
        })
        this.linkurl = url
      }
      this.$emit('onSave', this.generic)
    },
    onChangeMode: function () {
      if (this.$store.getters.getPackage != 'premium') {
        return false
      }
      if (this.isProductview == true) {
        delete this.generic.productid
      }
      this.isProductview = !this.isProductview
    },
    onClickPageinate: function (pageNum) {
      this.pageNumber = pageNum
      $('.v-dialog').animate({
        scrollTop: 0
      })
    },
    onSelectProduct: function (product) {
      this.generic.productid = product.id
      this.currentProduct = product
      this.$emit('onSave', this.generic)
      this.showProduct = false
    },
    onSave: function () {
      this.$emit('onSave', this.generic)
    },
    onGenericChange: function (generic) {
      // generic.enable = !generic.enable
      this.$emit('onDelete')
    },
    onCopyGenericCard(generic) {
      this.$emit('onCopy', generic)
    },
    addNewButton: function (payload) {
      if (this.generic.buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.generic.buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
      }
      this.saveTimestamp = moment().format('x')
    },
    editButton: function (index, payload) {
      if (this.generic.buttons[index]) {
        // this.generic.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.generic.buttons, index, payload)
      }
      this.editTimestamp = moment().format('x')
    },
    deleteButton: function (index) {
      this.generic.buttons.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/GenericManage.vue